import React, { useState } from 'react';
import { Card, Col, Row, Input, Button } from 'reactstrap';
import ReactTable from 'react-table';

/**
 * Product picker UI (props-only, no API calls).
 * Multi-select + Select All on filtered results.
 */
function MapProductPopup(props) {
  const productList = props.productList || [];
  const [searchText, setSearchText] = useState('');
  const [asins, setAsins] = useState(props.selectedAsins || []);

  const filterProductData = productList.filter(function (row) {
    const parentProduct = (row.parentProduct || '').toLowerCase();
    const productTitle = (row.productTitle || '').toString().toLowerCase();
    const asin = (row.asin || '').toString().toLowerCase();
    const term = (searchText || '').toLowerCase();
    if (!term) return true;
    return (
      parentProduct.indexOf(term) !== -1 ||
      asin.indexOf(term) !== -1 ||
      productTitle.indexOf(term) !== -1
    );
  });

  const selectedAsinList = function (asin) {
    setAsins(function (prev) {
      if (prev.indexOf(asin) !== -1) {
        return prev.filter(function (item) { return item !== asin; });
      }
      return prev.concat([asin]);
    });
  };

  const handleDone = function () {
    if (typeof props.setSelectedAsins === 'function') {
      props.setSelectedAsins(asins);
    }
    if (typeof props.onDone === 'function') {
      props.onDone(asins);
    }
    if (typeof props.setAddProductsPopup === 'function') {
      props.setAddProductsPopup(false);
    }
    if (typeof props.onClose === 'function') {
      props.onClose();
    }
  };

  const columns = [
    {
      Header: 'Select',
      accessor: 'asin',
      width: 80,
      sortable: false,
      filterable: false,
      Cell: function (cellInfo) {
        return (
          <div className="d-flex justify-content-center w-100">
            <input
              onChange={function () { selectedAsinList(cellInfo.value); }}
              value={cellInfo.value}
              type="checkbox"
              name={cellInfo.value}
              checked={asins.indexOf(cellInfo.value) !== -1}
            />
          </div>
        );
      },
    },
    {
      Header: 'Parent Asin',
      accessor: 'parentProduct',
      width: 110,
      Cell: function (cellInfo) {
        return (
          <div className="d-flex justify-content-center w-100">
            <p className="mb-0">{cellInfo.value}</p>
          </div>
        );
      },
    },
    {
      Header: 'Asin',
      accessor: 'asin',
      width: 110,
      Cell: function (cellInfo) {
        return (
          <div className="d-flex justify-content-center w-100">
            <p className="mb-0">{cellInfo.value}</p>
          </div>
        );
      },
    },
    {
      Header: 'Product Title',
      accessor: 'productTitle',
      Cell: function (cellInfo) {
        return (
          <div className="d-flex justify-content-start w-100">
            <p title={cellInfo.value} className="mb-0 comment-paragraph-ticket-history">
              {cellInfo.value}
            </p>
          </div>
        );
      },
    },
  ];

  return (
    <Card className="curve-popup p-3 border-0 shadow-none">
      <Row>
        <Col md={12}>
          <Input
            className="mb-2 w-50"
            value={searchText}
            onChange={function (e) { setSearchText(e.target.value); }}
            placeholder="Search product by Title and ASIN"
          />
          <div className="mb-2" style={{ fontSize: 13 }}>
            Selected: <b>{asins.length}</b>
          </div>
        </Col>
        <Col md={12}>
          <ReactTable
            data={filterProductData}
            columns={columns}
            className="-fixed -highlight -striped mt-2"
            getTheadProps={function () {
              return {
                style: {
                  overflowY: 'hidden',
                  background: '#B1FA63',
                  color: '#243837',
                },
              };
            }}
            getTrProps={function (state, rowInfo) {
              if (rowInfo && rowInfo.original && rowInfo.original.isParentProduct) {
                return {
                  style: {
                    backgroundColor: '#dfd7ff',
                  },
                };
              }
              return {};
            }}
            defaultPageSize={5}
            noDataText="No Data Found."
          />
        </Col>
        <Col className="d-flex justify-content-center mt-2">
          <Button className="btn-background-color" onClick={handleDone}>
            Done
          </Button>
        </Col>
      </Row>
    </Card>
  );
}

export default MapProductPopup;
